import { TablePagination } from "@mui/material";

interface CustomPaginationProps {
  tableOptions: any;
  rowsPerPage: number;
  page: number;
  handleChangePage: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
  handleChangeRowsPerPage: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  TablePaginationActions: (props: any) => JSX.Element;
  totalCount: number;
  rowsPerPageOptions: number[];
}

export default function CustomPagination({
  tableOptions,
  rowsPerPage,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
  TablePaginationActions,
  totalCount,
  rowsPerPageOptions,
}: CustomPaginationProps) {
  return (
    <TablePagination
      rowsPerPageOptions={rowsPerPageOptions}
      className="customPagination"
      colSpan={
        tableOptions.actionStatus || tableOptions.selectedRow
          ? tableOptions.tableHeadItems.length + 1
          : tableOptions.tableHeadItems.length
      }
      count={totalCount}
      rowsPerPage={rowsPerPage}
      page={page}
      SelectProps={{
        inputProps: {
          "aria-label": "rows per page",
        },
        native: true,
      }}
      sx={{ borderBottom: 0 }}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      ActionsComponent={TablePaginationActions}
    />
  );
}
